/* eslint-disable */
// Global styles — required here so Gatsby emits them as external CSS files
// rather than inlining 700KB+ of CSS into every page's HTML <head>.
require('./src/styles/poppins.css')
require('./src/styles/mainsite.css')
require('./src/styles/custom.css')
require('./src/styles/responsive.css')

const React = require('react')

/**
 * Derives the correct i18next language key from a URL pathname.
 *
 * gatsby-plugin-react-i18next stores the active language in
 * localStorage under the key 'gatsby-i18next-language' and reads it
 * back as its FIRST priority on every page render — before even looking
 * at the URL.  If that value is stale (e.g. 'fr' left over from a
 * previous visit), the plugin will use the wrong language even when the
 * current URL is clearly English.
 *
 * We fix this by writing the correct value to localStorage:
 *   • in onClientEntry  — before the very first React render (hard load)
 *   • in onPreRouteUpdate — before each client-side navigation renders
 *
 * HtmlLangSync below keeps <html lang> in sync as a secondary layer.
 */
const getUrlLang = (pathname) => {
  if (pathname.startsWith('/fr/')) return 'fr'
  if (pathname.startsWith('/es/')) return 'es'
  if (pathname.startsWith('/de/')) return 'de'
  return 'en-US'
}

/**
 * Runs before each client-side navigation renders the new page.
 * Setting localStorage here means the plugin reads the correct language
 * when it initialises the i18next context for the incoming page —
 * eliminating the flash where the previous language appears momentarily.
 */
exports.onPreRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return
  localStorage.setItem('gatsby-i18next-language', getUrlLang(location.pathname))
}

/**
 * Trust All Scripts
 *
 * This is a dirty little script for iterating over script tags
 * of your Ghost posts and adding them to the document head.
 *
 * This works for any script that then injects content into the page
 * via ids/classnames etc.
 *
 */
// const { datadogRum } = require('@datadog/browser-rum')

let headerStickHandler = null

const loadDelayedScripts = () => {
  const ric = typeof requestIdleCallback !== 'undefined' ? requestIdleCallback : (cb) => setTimeout(cb, 0)

  ric(() => {
    let popupRequestdemo = localStorage.getItem('showMsg')
    if (popupRequestdemo === 'false') {
      const footerb = document.getElementById('footerb')
      if (footerb) footerb.classList.remove('popupspc')
    }

    document.querySelectorAll('.mobile_listing').forEach((el) => {
      el.addEventListener('click', () => {
        const menu = el.querySelector('.dropdownmenu')
        if (menu) menu.classList.toggle('mobileMenuD')
      })
    })

    document.querySelectorAll('.listingMenu > a').forEach((a) => {
      a.addEventListener('click', (event) => event.preventDefault())
    })
  })

  ric(() => {
    if (headerStickHandler) {
      window.removeEventListener('scroll', headerStickHandler)
    }
    const headerStick = document.querySelector('.header_stick')
    if (headerStick) {
      headerStickHandler = () => {
        if (window.scrollY > 0) {
          headerStick.classList.add('navbar_fixed')
        } else {
          headerStick.classList.remove('navbar_fixed')
        }
      }
      window.addEventListener('scroll', headerStickHandler, { passive: true })
    }

    document.querySelectorAll('nav .navbar-nav a').forEach((a) => {
      if (a.href === window.location.href) {
        a.classList.add('active')
      }
    })
  })

  ric(() => {
    document.querySelectorAll('.mobileheader_menu li a').forEach((a) => {
      a.addEventListener('click', () => {
        const collapse = document.querySelector('.mobile_navbar .navbar-collapse')
        if (collapse) collapse.classList.toggle('show')
      })
    })

    document.querySelectorAll('.scrollToDownload').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        const href = el.getAttribute('href')
        const target = document.querySelector(href)
        if (target) {
          const offset = target.getBoundingClientRect().top + window.pageYOffset - 130
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    })

    document.querySelectorAll('.scrollto').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        const href = el.getAttribute('href')
        const target = document.querySelector(href)
        if (target) {
          const offset = target.getBoundingClientRect().top + window.pageYOffset - 250
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    })
  })
}

exports.onRouteUpdate = ({ location }) => {
  // Sync <html lang> with the current URL language on every client-side navigation.
  // gatsby-ssr.js handles the initial static HTML; this keeps it correct after navigation.
  const lang = getUrlLang(location.pathname)
  document.documentElement.lang = lang === 'en-US' ? 'en' : lang

  // Notify GTM of client-side route changes for accurate SPA page view tracking.
  // GTM should have a trigger listening for the 'gatsby_route_change' event.
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({ event: 'gatsby_route_change' })
  }

  // Defer non-critical scripts until after paint
  setTimeout(loadDelayedScripts, 300)
}

//add  revenueHero script
const {
  initPerformanceOptimizations,
  loadGTMOptimized,
  checkCountryOptimized,
} = require('./src/utils/thirdPartyOptimizer')

exports.onClientEntry = () => {
  // Fix localStorage language immediately on hard load / direct URL visit,
  // before the plugin reads it and before any React rendering begins.
  if (typeof window !== 'undefined') {
    localStorage.setItem('gatsby-i18next-language', getUrlLang(window.location.pathname))
  }

  // ── GTM: always allowed by default ────────────────────────────────────────
  // GTM loads for every visitor unless they have EXPLICITLY declined.
  // The interaction gate was removed — GTM must track all page views.
  // loadGTMOptimized uses requestIdleCallback internally so it won't block
  // initial rendering.
  //
  // Consent states (from localStorage.cookieConsentConfig):
  //   null                                    → no choice yet    → GTM loads (default allow)
  //   { allowCookie: true,  showConsentBar: false } → allowed   → GTM loads
  //   { allowCookie: false, showConsentBar: true  } → not chosen yet → GTM loads
  //   { allowCookie: false, showConsentBar: false } → declined   → GTM blocked
  const storedConsent = JSON.parse(localStorage.getItem('cookieConsentConfig'))
  const gtmDeclined = storedConsent?.allowCookie === false && storedConsent?.showConsentBar === false

  if (!gtmDeclined) {
    if (document.readyState === 'complete') {
      loadGTMOptimized('TDN6QG5')
    } else {
      window.addEventListener('load', () => loadGTMOptimized('TDN6QG5'), { once: true })
    }
  }

  // When the user accepts cookies in the same session (CookieConsent dispatches
  // a storage event), load GTM immediately before the page reloads.
  window.addEventListener('storage', () => {
    if (window.sessionStorage.getItem('allowGtm') === 'true') {
      loadGTMOptimized('TDN6QG5')
    }
  }, false)

  // ── Other third-party scripts ──────────────────────────────────────────────
  // HubSpot, RevenueHero and country detection are deferred to the first
  // user interaction so they don't block initial page rendering.
  const events = ['scroll', 'mousedown', 'touchstart', 'keydown']
  const loadThirdPartyScripts = () => {
    initPerformanceOptimizations()
    checkCountryOptimized().then((country) => {
      let storedState = JSON.parse(localStorage.getItem('cookieConsentConfig'))
      if (storedState == null) {
        setInitialLocalStorageStates(country, false, true)
      }
      createCustomEventToCheckLocalStorageChanges()
    })
    events.forEach((event) => document.removeEventListener(event, loadThirdPartyScripts, { passive: true }))
  }
  events.forEach((event) => document.addEventListener(event, loadThirdPartyScripts, { passive: true }))

  // Push form details to the dataLayer for offline conversion tracking
  if (typeof window !== 'undefined') {
    window.addEventListener(
      'message',
      (event) => {
        if (event.data?.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
          const submissionValues = event.data.data?.submissionValues || {}
          const email = submissionValues.email
          const phone = submissionValues.phone

          if (email || phone) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'enhanced_conversion',
              email: email,
              phone_number: phone,
            })
          }
        }
      },
      false
    )
  }
}

//revenue hero code
function executeRevenueHeroScript() {
  var targetFormIds = [
    `517ebc0a-e3b2-48e7-994d-19507b711e00`,
    `c169c509-7422-4098-bdd2-085a67d82092`,
    `e23ab1ed-02c7-42c1-90bc-ecd78ae786c3`,
    `3ba0360d-0fb0-4473-84c9-a7362657431c`,
    `568567fd-2abb-43a4-b030-a6e2d7875387`,
  ]
  if (typeof window === 'undefined') return
  if (window.addEventListener) {
    window.addEventListener('message', handleFormSubmitEvent, false)
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', handleFormSubmitEvent)
  }
  function handleFormSubmitEvent(event) {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
      var submittedData = event.data.data.submissionValues
      var formId = event.data.id
      // Check if the submitted form's ID is in the targetFormIds array
      if (targetFormIds.includes(formId)) {
        var formValues = event.data.data.submissionValues
        //replace routerID with the router ID you've setup
        const RevenueHero = window.RevenueHero
        const hero = new RevenueHero({ routerId: `1226` })
        hero.submit(formValues).then((sessionData) => {
          hero.dialog.open(sessionData)
        })
      }
    }
  }
}

//default id for english site
let setID = `TDN6QG5`

// This function is now replaced by checkCountryOptimized in thirdPartyOptimizer.js
// const checkCurrCountry = checkCountryOptimized

const createCustomEventToCheckLocalStorageChanges = () => {
  var evt = document.createEvent('StorageEvent')
  evt.initStorageEvent('storage', false, false, 'allowGtm', 'oldValue', 'newValue', null, window.localStorage)
  window.dispatchEvent(evt)
}

const setInitialLocalStorageStates = (...args) => {
  const [country, allowCookie, showConsentBar] = args
  let initialObj = JSON.stringify({
    showConsentBar: showConsentBar,
    allowCookie: allowCookie,
    country: country,
  })
  localStorage.setItem('cookieConsentConfig', initialObj)
}
